import * as UserActions from '../actions/user.actions'

function initialState() {
  return {
    linkBffClassroom: false,
  }
}

const userReducer = (state = initialState(), action) => {
  switch (action.type) {
    case UserActions.LINK_USER_CLASSROOM:
      return {
        ...state,
        linkBffClassroom: action.isLinked,
      }

    case UserActions.UPDATE_USER:
      return { ...state, ...action.payload }

    case UserActions.UPDATE_PROMOTION_TERMS:
      return { ...state, promotionTermsAccepted: action.payload }

    case UserActions.RESET_USER:
      return {}

    default:
      return state
  }
}

export default userReducer
